export default "__VITE_ASSET__a3fd49a5__"